/* istanbul ignore file */
export function MouseEvent(eventType, _params) {
  const params = _params || { bubbles: false, cancelable: false };
  const mouseEvent = document.createEvent('MouseEvent');
  // eslint-disable-next-line max-len
  mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

  return mouseEvent;
}

MouseEvent.prototype = Event.prototype;
